import React, { ReactElement } from "react";
import { useRefinementList, UseRefinementListProps } from "react-instantsearch";
import * as styles from "./RefinedListDropdown.module.scss";
import DropDownFilter, {
  DropDownFilterProps
} from "../DropDownFilter/DropDownFilter";
import RefinedListValues, {
  CounterLabelFunction,
  DescriptionForItem,
  TransformItems
} from "./RefinedListValues";
import { usePersistAlgoliaStateOnUnmount } from "components/FindYourCruise/Components/RefinementListFilter/usePersistAlgoliaStateOnUnmount";
import { defaultSelectedValuesLabel } from "./label";

export type DynamicTitleFunction = (count: number) => string;

type RefinedListDropdownProps = Omit<DropDownFilterProps, "children"> & {
  title?: string | ReactElement;
  dynamicTitle?: DynamicTitleFunction;
  operator: UseRefinementListProps["operator"];
  attribute: UseRefinementListProps["attribute"];
  limit: UseRefinementListProps["limit"];
  transformItems: TransformItems;
  descriptionForItem?: DescriptionForItem;
  counterLabel: CounterLabelFunction;
};

const RefinedListDropdown: React.FC<RefinedListDropdownProps> = ({
  title,
  dynamicTitle,
  operator,
  attribute,
  limit,
  transformItems,
  descriptionForItem,
  counterLabel,
  ...dropDownProps
}) => {
  usePersistAlgoliaStateOnUnmount();

  const { items, refine } = useRefinementList({
    attribute,
    operator,
    limit
  });
  const refinedItems = transformItems(items.filter((i) => i.isRefined));
  const titleOrDynamicTitle = dynamicTitle?.(refinedItems.length) || title;

  return (
    <DropDownFilter
      {...dropDownProps}
      selectedValuesLabel={defaultSelectedValuesLabel(refinedItems)}
      disabled={items.length == 0}
      title={titleOrDynamicTitle}
    >
      <RefinedListValues
        className={styles.list}
        refine={refine}
        items={items}
        descriptionForItem={descriptionForItem}
        transformItems={transformItems}
        counterLabel={counterLabel}
      />
    </DropDownFilter>
  );
};

export default RefinedListDropdown;
